<template>    
    <div class="accessIndex__locations">
        <!-- <div class="accessIndex__reload--container"
            @click="previousSelection()">
            <i class="material-icons" style="color: #009CDE">keyboard_backspace</i>
        </div> -->
        <v-flex xs12 row style="margin-bottom:15px">
            <p class="accessIndex__text--title" >Selecciona una sede</p>
        </v-flex>        
        <div
          class="accessIndex__locations--item_access"
          v-for="(location, index) in locations"
          @click="$emit('selected', {name: location.name, id: location.id, time_zone: location.time_zone})">
            <div class="accessIndex__locations--item_info">
                <div class="accessIndex__text--small_left">
                <p>{{location.name}}</p>
                </div>
            </div>
        </div>
      </div>
</template>

<script>
    export default {
        data() {
            return {
                locations:[],
            }
        },
        methods: {     
            requestPlanLocations(){  
                var vm = this;
                try{
                    vm.$http.post('app/locations/show_plan', {
                        headers: {
                            "X-Device-ID" : this.getDeviceId(),
                            "Authorization" : 'Bearer ' + this.getUserToken()
                        },
                        data: vm.encrypt(vm.$attrs.user[0].user_company).toString()
                    }).then(function(response){
                        /* console.log("RESPONSE") */
                        this.locations=response.body.locations;
                        /* console.log(response.body.locations) */
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                    }, function(response){
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                        console.log("Respuesta error de reservas");
                        if (response.status==401) { 
                            // this.updateAlertMessage(response.body.errors[0].details, "Un momento...");
                            this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                            this.updateIsInAlert(true)
                        }else{
                            this.updateAlertMessage(response.body.errors[0].details);
                            this.updateIsInAlert(true)
                        }
                    });
                }catch(e){
                  console.log("No fue posible encontrar locaciones para el usuario");
                  this.updateAlertMessage(e.message);
                  this.updateIsInAlert(true)
                }

                vm.is_changed = false;
            },
            previousSelection(){
                
            }
        },
        mounted(){
            var vm = this;   
            this.requestPlanLocations();
        }        
    }
</script>



// WEBPACK FOOTER //
// src/components/views/bookings/LocationSelect.vue